import { useNavigate } from 'react-router-dom'
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline'
import { DocumentTextIcon, ChevronRightIcon } from '@heroicons/react/20/solid'
import trainingPeaksLogo from 'media/integrations/training_peaks/TP_Preferred_Vertical Logo-Blue-Navy-2X.png'

import ScreenFrame from 'components/Frame/ScreenFrame'
import ContentFrame from 'components/Frame/ContentFrame'

export default function Resources() {

    const navigate = useNavigate()

    const OnAccessCalfPerformanceGuide = () => {
        const navigationProps = {
            state: {
                pdfURL: 'https://which-weight-public.s3.us-east-2.amazonaws.com/pdfs/Calf+Performance+Coach.pdf'
            }
        }

        navigate('/resources/pdf', navigationProps)
    }

    const OnAccessKneePerformanceGuide = () => {
        const navigationProps = {
            state: {
                pdfURL: 'https://which-weight-public.s3.us-east-2.amazonaws.com/pdfs/Knee+Performance+Coach.pdf'
            }
        }

        navigate('/resources/pdf', navigationProps)
    }

    const OnAccessTrainingPeaksStrengthCourse = () => {
        window.open('https://university.trainingpeaks.com/strength-training-for-endurance-coaches', '_blank')
    }

    return (
        <ScreenFrame>
            <div className='flex items-center gap-x-4'>
                <h1 className="text-2xl font-semibold text-gray-900 tracking-tight pt-2 flex-grow">
                    Resources
                </h1>
            </div>

            <ContentFrame>
                <div 
                    className="w-full flex items-center pl-6 pr-8 py-4 gap-x-6 cursor-pointer hover:bg-gray-50 transition-colors"
                    onClick={OnAccessCalfPerformanceGuide}
                >
                    <div className='h-16 w-16 bg-orange-400 rounded-full flex items-center justify-center'>
                        <DocumentTextIcon className="h-10 w-10 text-white" />
                    </div>

                    <div className="flex-grow space-y-0.5">
                        <div className="text-lg">Calf Performance Guide</div>
                        {/* <div className="text-sm">
                            Add description here
                        </div> */}
                    </div>

                    <ChevronRightIcon className="h-6 w-6 text-gray-400" />
                </div>
            </ContentFrame>

            <ContentFrame>
                <div 
                    className="w-full flex items-center pl-6 pr-8 py-4 gap-x-6 cursor-pointer hover:bg-gray-50 transition-colors"
                    onClick={OnAccessKneePerformanceGuide}
                >
                    <div className='h-16 w-16 bg-orange-400 rounded-full flex items-center justify-center'>
                        <DocumentTextIcon className="h-10 w-10 text-white" />
                    </div>

                    <div className="flex-grow space-y-0.5">
                        <div className="text-lg">Knee Performance Guide</div>
                        {/* <div className="text-sm">
                            Add description here
                        </div> */}
                    </div>

                    <ChevronRightIcon className="h-6 w-6 text-gray-400" />
                </div>
            </ContentFrame>

            <ContentFrame>
                <div 
                    className="w-full flex items-center px-8 py-6 gap-x-8 cursor-pointer hover:bg-gray-50 transition-colors"
                    onClick={OnAccessTrainingPeaksStrengthCourse}
                >
                    <img src={trainingPeaksLogo} alt="TrainingPeaks" className="w-40 mb-0.5" />

                    <div className="flex-grow space-y-0.5">
                        <div className="text-lg">TrainingPeaks Strength Course</div>
                        <div className="text-sm">
                            Use code <b>KinesisVIP</b> for access
                        </div>
                    </div>

                    <ArrowTopRightOnSquareIcon className="h-6 w-6 text-gray-400" />
                </div>
            </ContentFrame>
        </ScreenFrame>
    )
}
